export const BASE_URL = process.env.PUBLIC_URL;

export const HOME = "Home";
export const ABOUT = "About";
export const RESUME = "Resume";

export const NAV_ITEMS = [HOME, ABOUT, RESUME];
